import React from 'react';
import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { useTypewriter } from '@/utils/hooks/useTypewriter';

interface SmoothMarkdownProps {
  components?: Components;
  content: string;
  isGenerating?: boolean;
  processedContent?: string;
}

export const SmoothMarkdown: React.FC<SmoothMarkdownProps> = ({
  components,
  content,
  isGenerating = false,
  processedContent,
}) => {
  const displayedContent = useTypewriter(processedContent ?? content, {
    isGenerating,
  });

  return (
    <div className="relative">
      <ReactMarkdown
        components={components}
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm]}
      >
        {displayedContent}
      </ReactMarkdown>
    </div>
  );
};
